
/**
 *  05/04/2022 v 1.0 - JuanMa
 *  12/04/2022 v 1.1  Añadido metodo descargarDocumentoDeNotificacion
 *  13/01/2025 v 1.2  Añadido metodo descargarDocumentoDePresupuesto
 **/

import {servicioDocumental, servidor} from "../Configuracion";
import ClienteRestful from "../../framework2/ej2/network/ClienteRestful";

export const descargarDocumento= (elementoClassName, elementoCodigo, documento) => {
    console.log("descargarDocumento");
    console.log("elementoClassName: ", elementoClassName);
    console.log("elementoCodigo: ", elementoCodigo);
    console.log("documento: ", documento);

    let url= servidor + servicioDocumental + "download/" +
        elementoClassName + "/" + elementoCodigo + "/" + documento.nombre;
    console.log("url: ", url);
    const clienteRestful = new ClienteRestful().setUrl(url);
    clienteRestful.doGet(response => {
    });
}


